var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnfilledFav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "unfilled_fav") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_line_style_24px",
    transform: "translate(-1431 -13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3697",
    "data-name": "Rectangle 3697",
    width: 24,
    height: 24,
    transform: "translate(1431 13)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "star_FILL0_wght400_GRAD0_opsz24",
    d: "M8.85,17.825l3.15-1.9,3.15,1.925-.825-3.6,2.775-2.4-3.65-.325L12,8.125,10.55,11.5l-3.65.325L9.675,14.25ZM5.825,22,7.45,14.975,2,10.25l7.2-.625L12,3l2.8,6.625,7.2.625-5.45,4.725L18.175,22,12,18.275ZM12,13.25Z",
    transform: "translate(1431 13)",
    fill: "#758091"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfilledFav);
export default __webpack_public_path__ + "static/media/unfilled_fav.e7e63bfc390ece7a9bb8662476179e5a.svg";
export { ForwardRef as ReactComponent };